import { Avatar } from "@heroui/react";
import { useAuthState } from "/app/src/contexts/authentication";
import { NavLink } from "react-router-dom";

/**
 *
 * @returns Avatar
 */
export default function ClickableAvatar() {
  const { user } = useAuthState();
  const displayLetter = user?.username?.[0]?.toUpperCase() ?? "";

  if (!user) return null; // Wait for user to be defined before rendering

  return (
    <div className="flex items-center justify-center">
      <NavLink to={`/users/${user?.id}`}>
        <Avatar radius="full" name={displayLetter} color="primary" />
      </NavLink>
    </div>
  );
}
